var Incidents = {
    newProperty: '',
    currentProperty: '',
    currentPropertyItem: [],
    newPropertyItem: [],

    init: function() {
        Incidents.bindSearch();
        Incidents.bindPupilSelect();
        Incidents.bindDisableContextmenu();
        Incidents.bindToggleOptional();
        Incidents.bindSetManage();
        Incidents.bindAddProperty();
        Incidents.bindAddPropertySave();
        Incidents.bindManagePropertyButtons();
        Incidents.bindManagePropertySave();
        Incidents.bindBodyMap();
        Incidents.bindClearMarks();
        Incidents.bindBodymapCheck();
        Incidents.bindDelete();
        Incidents.bindManageModal();
        Incidents.bindCancel();
        Incidents.bindBehaviourPlanCheck();
        Incidents.bindFocusCheck();
        Incidents.bindSubmit();
        //Incidents.bindSave();
        Incidents.bindOverviewsByLocation();
        Incidents.bindLocationsBySite();
    },

    bindSearch: function() {
        $("#goSearch").on('click', function(e) {
            e.preventDefault();
            e.stopPropagation();

            var val = $('#search').val();
            $.get('/incidents/', {search:val})
                .done(function(data) {
                    //alert('Success!');
                    document.open();
                    document.write(data);
                    document.close();
                })
                .fail(function(xhr, status, error) {
                        alert('An AJAX error occurred: ' + status + "\n" + 'Error: ' + error);
                });
        });
    },

    bindSave: function() {
        $('#incidentSave').click(function(e) {
            e.preventDefault();
            $('#incidentsForm').submit();
        });
    },

    bindSubmit: function() {
        $('#incidentsForm').submit(function() {
            var button = $('#incidentSave');
            var html = '<img src="/images/ajax-loader.gif" class="btn-spinner"> Please wait...';
            button.html(html).attr('disabled', true);
        });
    },

    bindFocusCheck: function() {
        $('#focus').click(function() {
            $('#equals').text('');
            $('#incident-focus-equals').remove();
            var input = $(this);
            if (input.is(':checked')) {
                var focus = $('#incident-focus-select').find(":selected").text();
                if (focus == 'overviews' || focus == 'times' || focus == 'locations' ||
                    focus == 'levels of severity' || focus == 'types of intervention' ||
                    focus == 'days of the week' ||
                    focus == translatedExtraFocus1 || focus == translatedExtraFocus2 || focus == translatedExtraFocus3)
                {
                    Incidents.focusEqualsDropdown(encodeURIComponent(focus));
                }
                $('#focus-actions').slideDown('fast');
                return true;
            }
            $('#focus-actions').slideUp('fast');
        });

        $('#incident-focus-select').on('change', function() {
            $('#equals').text('');
            $('#incident-focus-equals').remove();
            var focus = $('#incident-focus-select').find(":selected").text();
            if (focus == 'overviews' || focus == 'times' || focus == 'locations' ||
                focus == 'levels of severity' || focus == 'types of intervention' ||
                focus == 'days of the week' ||
                focus == translatedExtraFocus1 || focus == translatedExtraFocus2 || focus == translatedExtraFocus3)
            {
                Incidents.focusEqualsDropdown(encodeURIComponent(focus));
            }
        });
    },

    focusEqualsDropdown: function(focus) {
        $('#incident-focus-select').after(
            '<span id="equals"> equals</span>\n' +
            '<select id="incident-focus-equals" name="focus_values[]" multiple="multiple"\n' +
            '   style="position: relative; top: 80px; margin-top: -80px; z-index: 1">\n' +
            '   <option value="" class="default-option" selected="">All</option>\n'
        );
        if (decodeURIComponent(focus) != 'days of the week') {
            $.get('/reports/incidents/' + focus + '/ajax', function (data) {
                // $.each(JSON.parse(data), function(key, value) {
                $.each(data, function (key, item) {
                    $('#incident-focus-equals').append('<option value="' + key + '">' + item + '</option>');
                });
            });
        } else {
            ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
                .forEach((item, key) =>
                    $('#incident-focus-equals').append('<option value="' + (key + 1) + '">' + item + '</option>'));
        }
        $('#incident-focus-equals').after('</select>');
    },

    bindBehaviourPlanCheck: function() {
        $('#behaviour-plan-check').click(function() {
            var textField = $('#behaviour-plan-text');
            if (!$(this).is(':checked')) {
                textField.slideUp('fast').attr('disabled', true);
                return;
            }
            textField.slideDown('fast').attr('disabled', false);
        });
    },

    bindCancel: function() {
        $('#property-delete-cancel').click(function() {
            Incidents.toggleManageModal(false);
        });
    },

    bindDelete: function() {
        $('#property-delete').click(function() {
            if (!$(this).hasClass('confirm')) {
                Incidents.toggleManageModal(true);
                return;
            }
            var originalId = Incidents.currentPropertyItem['id'];
            var property = Incidents.currentProperty;
            if (property.search('checkbox') < 0) {
                var newId = $('#manage-property-select').val();
                Incidents.newPropertyItem['id'] = newId;
                var selectedId = $('#' + property + '-current-id').val();
                var select = $('#property-' + property);
            } else {
                //var newId = $('#manage-property-checkbox').val();
                var newId = $('#manage-property-checkbox').find(':input:checked:first').val();
                Incidents.newPropertyItem['id'] = newId;
                var checkedIds = JSON.parse($('#' + property + '-current-id').val());
                var label = $('label[for="' + property + '"]');
                var checkbox = label.next().children('.row').first();
            }
            $.get('/incident-properties/delete?property=' + Incidents.currentProperty + '&original_id=' + originalId + '&new_id=' + newId, function(items) {
                items = App.sortProperties(items, false);
                if (property.search('checkbox') < 0) {
                    Incidents.fillPropertySelect(property, items, select);
                    if (selectedId != originalId) {
                        select.val(selectedId);
                    }
                } else {
                    Incidents.fillPropertyCheckbox(property, items, checkbox);
                    Array.from(checkedIds).forEach((checkedId, i) => {
                        if (checkedId != originalId) {
                            Incidents.checkAnId(checkbox, checkedId);
                        }
                    });
                }
                alert('Incident ' + property + ' deleted successfully!');
                $('#manage-property-modal').modal('hide');
            })
        });
    },

    checkAnId: function(checkbox, checkedId) {
        var boxes = checkbox.find(':input');
        boxes.each(function (i) {
            if ($(this).val() == checkedId) {
                $(this).prop('checked', true);
                return false;
            }
        });
    },

    bindManageModal: function() {
        $('#manage-property-modal').on('hidden.bs.modal', function() {
            Incidents.toggleManageModal();
        });
    },

    toggleManageModal: function(remove) {
        if (remove) {
            var deleteBtn = $('#property-delete');
            deleteBtn.removeClass('btn-secondary').addClass('btn-danger').addClass('confirm').html('<i class="fa fa-trash" aria-hidden="true"></i> Confirm');
            $('#property-delete-text').html('Select a new Incident ' + Incidents.currentProperty + ' to move incidents with this ' + Incidents.currentProperty + ' to.').show();
            if (Incidents.currentProperty.search('checkbox') < 0) {
                $('#manage-property-select-container').slideDown('fast');
            } else {
                $('#manage-property-checkbox-container').slideDown('fast');
            }
            $('#manage-property-name').slideUp('fast');
            $('#property-delete-cancel').show();
            $('#manage-property-save').hide();
            return;
        }
        $('#property-delete').removeClass('btn-danger').addClass('btn-secondary').removeClass('confirm').html('<i class="fa fa-trash" aria-hidden="true"></i> Delete');
        $('#property-delete-text').html('').hide();
        if (Incidents.currentProperty.search('checkbox') < 0) {
            $('#manage-property-select-container').slideUp('fast');
        } else {
            $('#manage-property-checkbox-container').slideUp('fast');
        }
        $('#manage-property-name').slideDown('fast');
        $('#property-delete-cancel').hide();
        $('#manage-property-save').show();

    },

    bindBodymapCheck: function() {
        $('#bodymap-check').click(function() {
            var bodymapRow = $('#bodymap-row');
            var bodymapButtons = $('#bodymap-buttons');
            if (!$(this).is(':checked')) {
                bodymapRow.slideUp('fast');
                bodymapButtons.slideUp('fast');
                return;
            }
            bodymapRow.slideDown('fast');
            bodymapButtons.slideDown('fast');
        });
    },

    bindDisableContextmenu: function() {
        $('input[name*="checkbox[]"]').contextmenu(function(e) {
            return false;
        });
    },

    bindToggleOptional: function() {
        $('#property-injury').on('change', function() {
            var injured = true;
            if (!$(this).find('option:selected').length) {
                injured = false;
            }
            $('.property-select').each(function() {
                if ($(this).attr('name') == 'severity' ||
                    $(this).attr('name') == 'intervention' ||
                    $(this).attr('name') == 'overview') {
                    if (injured) {
                        if ($(this).attr('required')) {
                            $(this).removeAttr('required');
                            var label = $('label[for="' + $(this).attr('id') + '"]');
                            if (label.text()) {
                                var mandatory = label.text();
                                var optional = mandatory.replace(/\*\:$/, ':');
                                label.text(optional);
                            }
                        }
                    } else {
                        if (typeof $(this).attr('required') === 'undefined' || !$(this).attr('required')) {
                            $(this).prop('required', true);
                            var label = $('label[for="' + $(this).attr('id') + '"]');
                            if (label.text()) {
                                var optional = label.text();
                                var mandatory = optional.replace(/\:$/, '*:');
                                label.text(mandatory);
                            }
                        }
                    }
                }
            });
        });
    },

    bindSetManage: function() {
        $('input[name*="checkbox[]"]').contextmenu(function(e) {
            var div = $(this).closest('div.checkbox-container');
            var divs = div.siblings();
            divs.each(function (i) {
                label = $('label', $(this));
                var html = label.html();
                if (html.search(' *Manage*') > -1) {
                    html = html.replace(' *Manage*', '');
                    label.html(html);
                }
            });
            var label = $(this).parent();
            var html = label.html();
            if (html) {
                if (html.search(' *Manage*') < 0) {
                    html = html + ' *Manage*';
                } else {
                    html = html.replace(' *Manage*', '');
                }
                label.html(html);
            }
            Incidents.bindSetManage();
            return false;
        });
    },

    bindAddProperty: function() {
        $('.add-property').click(function() {
            var property = $(this).data('property');
            var propertyNameElement =  $('#property-name');
            Incidents.newProperty = property;
            if (property.search('checkbox') < 0) {
                var propertySelect = $('#property-' + property);
                Incidents.currentPropertyItem['id'] = propertySelect.val();
                Incidents.currentPropertyItem['name'] =
                    propertySelect.find('option[value="' + Incidents.currentPropertyItem['id'] + '"]').text();
            } else {
                var label = $('label[for="' + property + '"]');
                var propertyCheckbox = label.next().children('.row').first();
                var boxes = propertyCheckbox.find(':input');
                boxes.each(function (i) {
                    var label = $(this).parent();
                    var html = label.html();
                    if (html.search(' *Manage*') > -1) {
                        Incidents.currentPropertyItem['id'] = $(this).val();
                        Incidents.currentPropertyItem['name'] = label.text().replace(' *Manage*', '');
                    }
                });
            }
            $('#add-property-title').html('Add incident ' + Incidents.newProperty);
            propertyNameElement.val('')
                .attr('placeholder', property.substr(0, 1).toUpperCase() + property.substr(1))
        });
    },

    bindAddPropertySave: function() {
        $('#add-property-save').click(function() {
            var property = Incidents.newProperty;
            var name = $('#property-name').val();
            if (property.search('checkbox') < 0) {
                var select = $('#property-' + property.toLowerCase());
            } else {
                var label = $('label[for="' + property + '"]');
                var checkbox = label.next().children('.row').first();
            }
            $.get('/incident-properties/add?property=' + property + '&name=' + name, function(items) {
                items = App.sortProperties(items, false);
                if (property.search('checkbox') < 0) {
                    Incidents.fillPropertySelect(property, items, select);
                } else {
                    Incidents.fillPropertyCheckbox(property, items, checkbox);
                }
                alert('Incident ' + property + ' added successfully!');
                $('#add-property-modal').modal('hide');
            });
        });
    },

    bindManagePropertyButtons: function()
    {
        $('.manage-property').click(function() {
            var property = $(this).data('property');
            var propertyNameElement = $('#manage-property-name');
            var propertyName = $(this).text();
            Incidents.currentProperty = property;
            if (property.search('checkbox') < 0) {
                var select = $('#manage-property-select');
                var propertySelect = $('#property-' + property);
                Incidents.currentPropertyItem['id'] = propertySelect.val();
                Incidents.currentPropertyItem['name'] = propertySelect.find('option[value="' + Incidents.currentPropertyItem['id'] + '"]').text();
            } else {
                checkbox = $('#manage-property-checkbox');
                var label = $('label[for="' + property + '"]');
                var propertyCheckbox = label.next().children('.row').first();
                var boxes = propertyCheckbox.find(':input');
                boxes.each(function (i) {
                    var label = $(this).parent();
                    var html = label.html();
                    if (html.search(' *Manage*') > -1) {
                        Incidents.currentPropertyItem['id'] = $(this).val();
                        Incidents.currentPropertyItem['name'] = label.text().replace(' *Manage*', '');
                    }
                });
            }
            $('#manage-property-title').html('Manage Incident ' + propertyName + ': ' + Incidents.currentPropertyItem['name']);
            propertyNameElement.val('').attr('placeholder', 'New name');
            if (property.search('checkbox') > -1) {
                Incidents.toggleManageActions();
            }
            $.get('/incident-properties/get?property=' + property, function(items) {
                items = App.sortProperties(items, false);
                if (property.search('checkbox') < 0) {
                    Incidents.fillPropertySelect(property, items, select);
                } else {
                    Incidents.fillPropertyCheckbox(property, items, checkbox);
                }
            });
        });
    },

    toggleManageActions: function() {
        $('#manage-property-message').html('');
        $('#manage-property-save').prop('disabled', false);
        if ($._data($("#property-delete")[0], "events") === undefined ||
            $._data($("#property-delete")[0], "events").click === undefined) {
            Incidents.bindDelete();
        };
        if (Incidents.currentPropertyItem['name'] === undefined) {
            $('#manage-property-message').html('*** Please Right Click on a checkbox to Update/Delete ***');
            $('#manage-property-save').prop('disabled', true);
            $('#property-delete').off('click');
        }
    },

    bindManagePropertySave: function() {
        $('#manage-property-save').click(function() {
            var nameInput = $('#manage-property-name');
            if (nameInput.val() != '') {
                var name = nameInput.val();
                var property = Incidents.currentProperty;
                if (property.search('checkbox') < 0) {
                    var select = $('#manage-property-select');
                    var propertySelect = $('#property-' + property);
                } else {
                    var checkbox = $('#manage-property-select-container').find('.row');
                    var label = $('label[for="' + property + '"]');
                    var propertyCheckbox = label.next().children('.row').first();
                }
                var id = Incidents.currentPropertyItem['id'];
                $.get('/incident-properties/rename?property=' + property + '&id=' + id + '&name=' + name, function(items) {
                    items = App.sortProperties(items, false);
                    if (property.search('checkbox') < 0) {
                        Incidents.fillPropertySelect(property, items, select);
                    } else {
                        Incidents.fillPropertyCheckbox(property, items, checkbox);
                    }
                    alert('Incident ' + property + ' updated successfully!');
                    nameInput.val('');
                    if (property.search('checkbox') < 0) {
                        Incidents.fillPropertySelect(property, items, select);
                        Incidents.fillPropertySelect(property, items, propertySelect);
                    }  else {
                        Incidents.fillPropertyCheckbox(property, items, checkbox);
                        Incidents.fillPropertyCheckbox(property, items, propertyCheckbox);
                    }
                    $('#manage-property-modal').modal('hide');
                });
            }
        });
    },

    fillPropertySelect: function(property, items, select) {
        var text = Incidents.setPropertySelectPlaceholder(property);
        select.empty();
        var defaultOption = "<option class='default-option' value='' selected disabled>" + text + "</option>";
        select.append(defaultOption);

        if (property == 'intervention') {
            var option = '<option>None</option>';
            select.append(option);
        }

        for (var x = 0; x < items.length; x++) {
            var item = items[x];
            var selectOption = '';
            if (item[0] == Incidents.currentPropertyItem['id'] || item[0] == Incidents.newPropertyItem['id']) {
                if (select.attr('id') == 'manage-property-select') {
                    selectOption = 'disabled';
                } else {
                    selectOption = 'selected';
                }
            }
            option = '<option value="'+ item[0] +'"'+ selectOption  +'>'+ item[1] +'</option>';
            select.append(option);
        }
        Incidents.newPropertyItem = [];
    },

    setPropertySelectPlaceholder: function(property) {
        property = property.toLowerCase();
        var text = 'Click to see list of items ? ' + property + ' ? unknown';
        if (property == 'overview') {
            text = 'Click to see list of ' + translatedOverview + 's';
        } else if (property == 'injury') {
            text = 'Click to see list of '  + translatedInjury;
        } else if (property == 'time') {
            text = 'Click to see list of '  + translatedTime + 's';
        } else if (property == 'site') {
            text = 'Click to see list of ' + translatedSite + 's';
        } else if (property == 'location') {
            text = 'Click to see list of ' + translatedLocation + 's';
        } else if (property == 'intervention') {
            text = 'Click to see list of ' + translatedIntervention + 's';
        } else if (property == 'severity') {
            text = 'Click to see levels of ' + translatedSeverity;
        } else if (property == 'default_email') {
            text = 'Click to see list of '  + translatedDefaultEmail;
        } else if (property == 'extra_focus1') {
            text = 'Click to see levels of ' + translatedExtraFocus1;
        } else if (property == 'extra_focus2') {
            text = 'Click to see levels of ' + translatedExtraFocus2;
        } else if (property == 'extra_focus3') {
            text = 'Click to see levels of ' + translatedExtraFocus3;
        } else if (property == 'zz401_dropdown') {
            text = 'Click to see levels of ' + translatedZz401Dropdown;
        } else if (property == 'zz402_dropdown') {
            text = 'Click to see levels of ' + translatedZz402Dropdown;
        } else if (property == 'zz403_dropdown') {
            text = 'Click to see levels of ' + translatedZz403Dropdown;
        } else if (property == 'zz404_dropdown') {
            text = 'Click to see levels of ' + translatedZz404Dropdown;
        } else if (property == 'zz405_dropdown') {
            text = 'Click to see levels of ' + translatedZz405Dropdown;
        } else if (property == 'zz406_dropdown') {
            text = 'Click to see levels of ' + translatedZz406Dropdown;
        } else if (property == 'zz407_dropdown') {
            text = 'Click to see levels of ' + translatedZz407Dropdown;
        } else if (property == 'zz408_dropdown') {
            text = 'Click to see levels of ' + translatedZz408Dropdown;
        } else if (property == 'zz409_dropdown') {
            text = 'Click to see levels of ' + translatedZz409Dropdown;
        }
        return text;
    },

    fillPropertyCheckbox: function(property, items, checkbox) {
        var boxes = checkbox.find(':input');
        checkbox.empty();
        var cols = items.length;

        for (var x = 0; x < items.length; x++) {
            var item = items[x];
            var checkOption = '';
            if (item[0] == Incidents.currentPropertyItem['id'] || item[0] == Incidents.newPropertyItem['id']) {
                if (checkbox.attr('id') == 'manage-property-checkbox') {
                    //checkOption = 'omitted';
                    continue;
                } else {
                    checkOption = 'checked';
                }
            }
            if (checkbox.attr('id') != 'manage-property-checkbox') {
                /* ascertain which boxes originally checked
                if ($(boxes[x]).is(':checked')) {
                    checkOption = 'checked';
                }
                */
                $(boxes).each(function() {
                    if ($(this).val() == item[0] && $(this).is(':checked')) {
                        checkOption = 'checked';
                        return false;
                    }
                });
            }
            var container = '';
            if (cols == 2) {
                container = '<div class="checkbox-container col-sm-12 col-24 pull-left">';
            } else if (cols == 3) {
                container = '<div class="checkbox-container col-sm-8 col-24 pull-left">';
            } else {
                container = '<div class="checkbox-container col-sm-24 col-24">';
            }
            string = 'checked="checked"';
            //if (!checked[x] && checkOption != 'checked') {
            if (checkOption != 'checked') {
                container = container +
                    '<label><input type="checkbox" class="" name="' + property + '[]" id="' + property + item[0] + '"' +
                    'placeholder="" value="' + item[0] + '"> ' + item[1] + '</label>' +
                    '</div>';
            } else {
                container = container +
                    '<label><input type="checkbox" class="" name="' + property + '[]" id="' + property + item[0] + '"' +
                    'placeholder="" value="' + item[0] + '" ' + string + '> ' + item[1] + '</label>' +
                    '</div>';
            }
            checkbox.append(container);
        }
        Incidents.newPropertyItem = [];
        Incidents.bindSetManage();
    },

    bindPupilSelect: function() {
        $('#incident-pupil').change(function() {
            var pupilId = $(this).val();
            $('#incident-other-pupils option').removeAttr('disabled');
            $('#incident-other-pupils').find('option[value="'+ pupilId + '"]').attr('disabled', true);
            $('.select2').select2();
        });
    },

    bindClearMarks:function() {
        $('.clear-marks').click(function() {
            var side = $(this).data('side');
            if (side == 'both') {
                $('.bodymap-mark').remove();
                $('.bodymap-input').remove();
                return;
            }
            $('.mark-' + side).remove();
            $('.input-' + side).remove();
        })
    },

    bindBodyMap: function() {
        $('.bodymap').click(function(e) {
            var bodymap = $(this);
            if ($('#bodymap-check').is(':checked')) {
                //var parentOffset = bodymap.parent().offset();
                var parentOffset = bodymap.parents('#bodymap-container').offset();
                var relX = e.pageX - parentOffset.left;
                var relY = e.pageY - parentOffset.top;
                var iconX = relX - 24;
                var iconY = relY - 13;
                var side = bodymap.data('side');
                var count = $('.bodymap-mark').length;
                var newMark = '<i id="mark-' + count + '" class="fa fa-times bodymap-mark mark-' + side +'" draggable="true"></i>';
                //$(newMark).insertBefore($('#bodymap-front')).css('transform', 'translate(' + (iconX) + 'px,' + (iconY) + 'px)');
                $(newMark).insertBefore($('#bodymap-images')).css('transform', 'translate(' + (iconX) + 'px,' + (iconY) + 'px)');
                var input = '<input type="hidden" class="bodymap-input input-' + side +'" name="bodymap[' + side +'][]" value="' + iconX + ',' + iconY + '">';
                $('#bodymap-container').append(input);
            }
        });
    },

    bindOverviewsByLocation: function () {
        if ($('select').hasClass('location-overviews')) {
            Incidents.filterOverviewsByLocation();
        }
        $('.location-overviews').change(function() {
            Incidents.filterOverviewsByLocation();
        })
    },

    filterOverviewsByLocation: function (selector) {
        var selectedOverviewVal = $('#property-overview :selected').val();
        var location = $('#property-location :selected').text();
        // regular expression for text between any parenthesis ()
        //var regExp = /\(([^)]+)\)/g;
        // regular expression for text between first parenthesis ()
        var regExp = /\(([^)]+)\)/;
        // regular expression for absence of parenthesis ()
        var regExp2 = /^((?!\(.*\)).)*$/;
        // get first alpha letter
        //var letter = (location.match(/[a-zA-Z]/) || []).pop();
        // get first alphas within parenthesis
        var alphas = (location.match(regExp) || []).pop();
        var overviews = [];
        $.get('/incidents/ajax-overviews', function (data) {
            var obj = JSON.parse(data);
            overviews = obj.results;
            var locationOverviews = $.grep(overviews, function(v) {
                // filter Overviews on contents of initial parenthesis matching Location letter or empty array
                //return (v.text.match(/[a-zA-Z]/) || []).pop() == letter;
                // filter Overviews on contents of initial parenthesis matching Location alphas
                // or don't filter at all if there is no alphas string or there are no parentheses
                return (v.text.match(regExp) || []).pop() == alphas || alphas === undefined || v.text.match(regExp2);
            });
            $('#property-overview').empty().trigger('change');
            optionsData = [{id: '', text: 'Click to see list of Overviews'}];
            Array.prototype.push.apply(optionsData,locationOverviews);
            $('#property-overview').select2({data: optionsData}).trigger('change');
            $('#property-overview').val(selectedOverviewVal).trigger('change');
        });
    },

    bindLocationsBySite: function () {
        if ($('select').hasClass('site-locations')) {
            Incidents.filterLocationsBySite();
        }
        $('.site-locations').change(function() {
            Incidents.filterLocationsBySite();
        })
    },

    filterLocationsBySite: function (selector) {
        var selectedLocationVal = $('#property-location :selected').val();
        var site = $('#property-site :selected').text();
        // regular expression for text between first parenthesis ()
        var regExp = /\(([^)]+)\)/;
        // regular expression for absence of parenthesis ()
        var regExp2 = /^((?!\(.*\)).)*$/;
        // get first alphas within parenthesis
        var alphas = (site.match(regExp) || []).pop();
        var locations = [];
        $.get('/incidents/ajax-locations', function (data) {
            var obj = JSON.parse(data);
            locations = obj.results;
            var siteLocations = $.grep(locations, function(v) {
                // filter Locations on contents of initial parenthesis matching Site alphas
                // or don't filter at all if there is no alphas string or there are no parentheses
                return (v.text.match(regExp) || []).pop() == alphas || alphas === undefined || v.text.match(regExp2);
            });
            $('#property-location').empty().trigger('change');
            optionsData = [{id: '', text: 'Click to see list of Locations'}];
            Array.prototype.push.apply(optionsData,siteLocations);
            $('#property-location').select2({data: optionsData}).trigger('change');
            $('#property-location').val(selectedLocationVal).trigger('change');
        });
    },
};
